export const server = "https://jjayai-0da2b868a568.herokuapp.com/";
// export const server = "http://localhost:8000/";
